import React from "react";
import { InputContainer } from "../../../../../../common/components/form/form.module";


export default function TaxonomyDetailComponent({ selectMobility, distances, products, productTypes, variants, taxonomy, handleTaxonomyFormChange, removeTaxonomy, addTaxonomyRow }: any) {


    return (
        <>
            {/* Vehicle Info Table */}

            <table className="w-full border mb-4">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="border p-2 w-24">Product Type</th>
                        <th className="border p-2 w-40">Product</th>
                        <th className="border p-2 w-16">Variant</th>
                        <th className="border p-2 w-28">Charge</th>
                        <th className="border p-2 w-20">unit</th>
                        <th className="border p-2 w-16">Min Dist</th>
                        <th className="border p-2 w-20">Max Dist</th>
                        <th className="border p-2 w-16">Dist Incr</th>
                        <th className="border p-2 w-24">Incr Charge</th>
                        <th className="border p-2 w-16">Is Prod BasePrice</th>
                        <th className="border p-2 w-10">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {taxonomy?.map((v, idx) => (
                        <tr key={idx}>

                            <td className="border p-1">

                                <InputContainer

                                    labelField="Name"
                                    list={productTypes.filter(
                                        (v: any) => v.Name == selectMobility?.RateCardType
                                    )}
                                    onValueChange={(e: any) => {
                                        handleTaxonomyFormChange(idx, "ProductTypeName", e.target.value)
                                    }}
                                    optionName='Choose ProductType'
                                    type="select"
                                    value={v?.ProductTypeName}
                                    valueField="Name"
                                />
                            </td>
                            <td className="border  p-1">

                                <InputContainer

                                    labelField="Name"
                                    list={products}
                                    onValueChange={(e: any) => {
                                        const selected = products.find(
                                            (p: any) => p.Name == e.target.value
                                        );
                                        console.log(selected, 'selected')
                                        handleTaxonomyFormChange(idx, "ProductId", selected?.Id)
                                        handleTaxonomyFormChange(idx, "ProductName", selected?.Name)
                                    }}
                                    optionName='Choose ProductName'
                                    type="select"
                                    value={v.ProductName}
                                    valueField="Name"
                                />
                            </td>
                            <td className="border p-1">

                                <InputContainer

                                    labelField="Name"
                                    list={variants}
                                    onValueChange={(e: any) => {
                                        handleTaxonomyFormChange(idx, "VariantName", e.target.value)
                                    }}
                                    optionName='Choose Variant'
                                    type="select"
                                    value={v.VariantName}
                                    valueField="Name"
                                />
                            </td>
                            <td className="border p-1">

                                <InputContainer

                                    name="Charge"
                                    onValueChange={(e: any) => {
                                        handleTaxonomyFormChange(idx, "Charge", Number(e.target.value))
                                    }}
                                    type="number"
                                    value={v.Charge}
                                />



                            </td>
                            <td className="border p-1">
                                <InputContainer

                                    labelField="SystemKeyword"
                                    list={distances}

                                    onValueChange={(event: any) => {

                                        handleTaxonomyFormChange(idx,

                                            'DistanceUnitId', event.target.value,

                                        )
                                    }}
                                    optionName='Choose Unit'
                                    type="select"
                                    value={v?.DistanceUnitId}
                                    valueField="Id"
                                />
                            </td>
                            <td className="border p-1">
                                <InputContainer
                                    name="MinimunDistance"
                                    onValueChange={(event: any) => {
                                        handleTaxonomyFormChange(idx,

                                            'MinimunDistance', event.target.value,

                                        )
                                    }}
                                    type="number"
                                    value={v?.MinimunDistance}
                                />
                            </td>
                            <td className="border p-1">
                                <InputContainer
                                    name="MaximumDistance"
                                    onValueChange={(event: any) => {
                                        handleTaxonomyFormChange(idx,

                                            'MaximumDistance', event.target.value,

                                        )
                                    }}
                                    type="number"
                                    value={v?.MaximumDistance}
                                />
                            </td>
                            <td className="border p-1">
                                <InputContainer
                                    name="DistanceIncrement"
                                    onValueChange={(event: any) => {
                                        handleTaxonomyFormChange(idx,

                                            'DistanceIncrement', event.target.value,

                                        )
                                    }}
                                    type="number"
                                    value={v?.DistanceIncrement}
                                />
                            </td>
                            <td className="border p-1">
                                <InputContainer
                                    name="DistanceIncrementCharge"
                                    onValueChange={(event: any) => {
                                        handleTaxonomyFormChange(idx,
                                            'DistanceIncrementCharge', event.target.value,

                                        )
                                    }}
                                    type="number"
                                    value={v?.DistanceIncrementCharge}
                                />
                            </td>
                            <td className="border p-1">

                                <InputContainer

                                    name="IsIncludeProductBasePrice"
                                    onValueChange={(e: any) => {
                                        handleTaxonomyFormChange(idx, "IsIncludeProductBasePrice", (e))
                                    }}
                                    type="checkbox"
                                    value={v.IsIncludeProductBasePrice}
                                />



                            </td>

                            <td className="border p-1 item-center">

                                <div className="flex items-center justify-center">
                                    <svg xmlns="http:www.w3.org/2000/svg" onClick={() => removeTaxonomy(idx)} width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM13.4142 13.9997L15.182 15.7675L13.7678 17.1817L12 15.4139L10.2322 17.1817L8.81802 15.7675L10.5858 13.9997L8.81802 12.232L10.2322 10.8178L12 12.5855L13.7678 10.8178L15.182 12.232L13.4142 13.9997ZM9 4V6H15V4H9Z"></path></svg>

                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button
                type="button"
                className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                onClick={(e) => {
                    e.preventDefault();
                    addTaxonomyRow();
                }}
            >
                + Add Vehicle Row
            </button>

        </>

    );
}
